// extracted by mini-css-extract-plugin
module.exports = {"bookmarkTitle":"_3n6ADgJUy_j0EOFDxax0-w","vendorNoDescriptionSpacer":"_1gFYLegxZtXPsPgxKO7KLY","tagCloudWidgetContainer":"_36Ju6sFXSCzBIjkxgAj3Bo"};